import React, { useEffect, useState } from "react";
import { publicApi } from "../lib/adminApi";

export default function AvailabilityCalendar({ slug }) {
  const [hasSource, setHasSource] = useState(false);

  useEffect(() => {
    let cancelled = false;
    publicApi.get(`/availability/${slug}`)
      .then((r) => {
        const blocks = r.data?.blocked || [];
        if (!cancelled) setHasSource(blocks.length > 0);
      })
      .catch(() => { if (!cancelled) setHasSource(false); });
    return () => { cancelled = true; };
  }, [slug]);

  return (
    <div className="border border-charcoal/15 bg-ivory p-5 md:p-6" data-testid="availability-calendar">
      <div className="text-[11px] tracking-[.25em] uppercase text-burgundy">Dostupnost</div>
      <div className="font-serif text-xl mt-2">Dostupnost termínu vám rádi ověříme</div>
      <p className="mt-3 text-sm text-charcoal/75 leading-relaxed">
        Dostupnost ověřujeme osobně. Pošlete nám požadovaný termín a počet hostů a ozveme se s potvrzením.
      </p>
      <a
        href="#poptavka"
        className="mt-4 inline-block text-sm border border-burgundy text-burgundy px-4 py-2 hover:bg-burgundy hover:text-ivory transition-colors"
        data-testid="calendar-enquiry-cta"
      >
        Odeslat poptávku termínu
      </a>
    </div>
  );
}
